import React, { useEffect, useState } from 'react';
import { SkillScenarioPath } from './SkillScenarioPath';
import { Spinner } from './Spinner';
import { SkillMapService, type SkillMap } from '../services/skillMapService';
import '../styles/skill-body-map.css';

// AXISREF499: the scenario check as its own Skill Manager tab. Describe a referral and see which
// urgency skills it would meet on the way to a priority.

export const SkillScenarioPanel: React.FC = () => {
  const [data, setData] = useState<SkillMap | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [region, setRegion] = useState('knee');

  const load = async () => {
    try {
      setError(null);
      setData(await SkillMapService.getSkillMap());
    } catch (err) {
      console.error('Failed to load skill map:', err);
      setError('Failed to load the skills. Please try again.');
    }
  };

  useEffect(() => {
    load();
  }, []);

  if (error && !data) {
    return (
      <div className="error-banner">
        <span>{error}</span>
        <button className="btn btn-link" onClick={load}>Retry</button>
      </div>
    );
  }

  if (!data) {
    return (
      <div className="loading-state">
        <Spinner size="md" />
        <p>Loading skills...</p>
      </div>
    );
  }

  const known = data.regions.some(r => r.code === region) ? region : data.regions[0]?.code ?? region;

  return (
    <SkillScenarioPath

      skills={data.skills}
      regions={data.regions}
      region={known}
      onRegionChange={setRegion}
    />
  );
};
